import { todayUpdates } from '@/mocks/movies';

export default function TopTicker() {
  const loop = [...todayUpdates, ...todayUpdates];
  return (
    <div className="w-full bg-primary-600 text-background-50">
      <div className="flex items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 py-2 text-xs font-medium md:text-sm">
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-live-line text-sm" aria-hidden="true"></i>
          </span>
          今日更新 {todayUpdates.length} 条
        </span>
        <span className="hidden h-4 w-px shrink-0 bg-background-50/30 sm:block" aria-hidden="true"></span>
        <div className="relative flex-1 overflow-hidden">
          <div className="ticker-track">
            {loop.map((item, index) => (
              <span
                key={`${item.id}-${index}`}
                className="mr-8 flex shrink-0 items-center gap-2 whitespace-nowrap py-2 text-xs text-background-50/90 md:text-sm"
              >
                <i className="ri-time-line text-sm" aria-hidden="true"></i>
                <span className="font-medium">{item.time}</span>
                <span>{item.title}</span>
                <span className="rounded-full bg-background-50/20 px-2 py-0.5 text-[11px]">{item.type}</span>
              </span>
            ))}
          </div>
        </div>
        <a
          href="#today"
          className="hidden shrink-0 items-center gap-1 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-background-50/25 md:inline-flex"
        >
          查看全部
          <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
        </a>
      </div>
    </div>
  );
}